module.exports = __webpack_public_path__ + "img/dialog_bg3.c68b86a1.jpg";